export const GITCARD_LOADING = 'REDUX_SAGA_GITCARD_LOADING';
export const GET_GITCARD_DATA_SUCCESS = 'REDUX_SAGA_GET_GITCARD_DATA_SUCCESS';
export const RESET_GITCARD = "REDUX_SAGA_RESET_GITCARD";
export const GET_GITCARD_DATA_ERROR = 'REDUX_SAGA_GET_GITCARD_DATA_ERROR';
export const UPATE_GITCARD_DATA = 'REDUX_SAGA_UPATE_GITCARD_DATA';
export const UPDATE_GIFTCARD_QUANTITY = 'REDUX_SAGA_UPDATE_GIFTCARD_QUANTITY';
export const UPDATE_GIFTCARD_CUSTOMAMOUNT = 'REDUX_SAGA_UPDATE_GIFTCARD_CUSTOMAMOUNT';
export const ADDTOCART_GIFTCARD = 'REDUX_SAGA_ADDTOCART_GIFTCARD';
export const REMOVE_GIFTCARD = 'REDUX_SAGA_REMOVE_GIFTCARD';

export const actionGetGiftCards = (dispatch, displayAreaNo) => {
    dispatch({ type: GITCARD_LOADING, payload: { displayAreaNo: displayAreaNo } })
};

export const actionUpdateGiftCardDropDown = (dispatch, key, price) => {
    dispatch({ type: UPATE_GITCARD_DATA, payload: { key: key, price: price } })
};

export const actionUpdateGiftCrdQuantity = (dispatch, ProductID, Quantity, IsCheckOut) => {
    dispatch({ type: UPDATE_GIFTCARD_QUANTITY, payload: { ProductID, Quantity, IsCheckOut } })
}

export const actionUpdateGiftCardCustomAmout = (dispatch, ProductID, Value) => {
    dispatch({ type: UPDATE_GIFTCARD_CUSTOMAMOUNT, payload: { ProductID, Value } })
}

export const actionAddToCartGiftCards = (dispatch, DisplayArea) => {
    dispatch({ type: ADDTOCART_GIFTCARD, payload: { DisplayArea } })
};

export const actionRemoveGiftCard = (dispatch, ProductID) => {
    dispatch({ type: REMOVE_GIFTCARD, payload: { ProductID } })
}

export const actionResetGiftCards = (dispatch) => {
    dispatch({ type: RESET_GITCARD })
};